module.exports = __webpack_public_path__ + "a223701fef7d2c08101f0fe46d1e1ade.pdf";